<template>
  <div>

    <router-view></router-view>
  </div>
</template>

<script>
  export default {}
</script>
<style>
  
  
/*[ FONT ]*/

@font-face {
    font-family: Poppins-Regular!important;
    src: url('../public/fonts/poppins/Poppins-Regular.ttf'); 
  }

    @font-face {
    font-family: Poppins-Medium!important;
    src: url('../public/fonts/poppins/Poppins-Medium.ttf'); 
  }
  
  @font-face {
    font-family: Poppins-Bold!important;
    src: url('../public/fonts/poppins/Poppins-Bold.ttf'); 
  }
  
  @font-face {
    font-family: Poppins-SemiBold!important;
    src: url('../public/fonts/poppins/Poppins-SemiBold.ttf'); 
  }

  body {
    font-family: 'Poppins', sans-serif!important;
        }


  


</style>
